import { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Dialog, { DialogTitle, DialogContent, DialogActions } from 'beam/dist/Dialog'
import Button from 'beam/dist/Button'
import { CircularProgress } from 'beam/dist/Progress'
import Typography from 'beam/dist/Typography'
import { Table, TableRow, TableHead, TableBody, TableCell } from 'beam/dist/Table'
import withStyles from 'beam/dist/styles/index'
import moment from 'moment'
import { toHumanReadable } from 'beam/dist/utils/index'
import { take } from 'lodash'
import classNames from 'classnames'

const autoQaIdPrefix = 'FindSimilarDialog-'

const styles = theme => ({
  loading: {
    textAlign: 'center',
  },
  idCell: {
    color: theme.palette.secondary.main,
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  contactTableContainer: {
    overflowX: 'auto',
    width: '100%',
  },
  contactTableCell: {
    padding: theme.spacing(1),
    whiteSpace: 'nowrap',
  },
  tableBody: {
    '& tr:nth-child(odd)': {
      background: theme.palette.grey[100],
    },
  },
  tableHeader: {
    background: theme.palette.primary.main,
    '& th': {
      color: theme.palette.primary.contrastText,
    },
  },
})

class FindSimilarDialog extends Component {
  static propTypes = {
    similarContacts: PropTypes.array.isRequired,
    open: PropTypes.bool,
    loading: PropTypes.bool,
    error: PropTypes.object,
    onOpen: PropTypes.func,
    onClose: PropTypes.func.isRequired,
    openContact: PropTypes.func,
    t: PropTypes.func.isRequired,
    classes: PropTypes.object,
  }

  static defaultProps = {
    open: false,
    loading: false,
    error: null,
    onOpen: () => {},
    openContact: () => {},
  }

  state = {
    isErrorsOpen: false,
  }

  renderContactRow(contact, i) {
    const { classes, t, openContact } = this.props
    return (
      <TableRow key={i}>
        <TableCell
          className={classNames(classes.contactTableCell, classes.idCell)}
          onClick={() => openContact(contact.id)}
        >
          {contact.id}
        </TableCell>
        <TableCell className={classes.contactTableCell}>
          {contact.contactType ? t(contact.contactType.toLowerCase()) : t('surveyScore_none')}
        </TableCell>
        <TableCell className={classes.contactTableCell}>
          {contact.agent ? contact.agent.firstName : t('surveyScore_none')}
        </TableCell>
        <TableCell className={classes.contactTableCell}>
          {contact.agent ? contact.agent.lastName : t('surveyScore_none')}
        </TableCell>
        <TableCell className={classes.contactTableCell}>{moment(contact.startTime).format('L')}</TableCell>
        <TableCell className={classes.contactTableCell}>{moment(contact.startTime).format('LT')}</TableCell>
        <TableCell className={classes.contactTableCell}>
          {contact.callDuration ? toHumanReadable(contact.callDuration) : t('surveyScore_none')}
        </TableCell>
      </TableRow>
    )
  }

  renderContactsTable() {
    const { similarContacts, t, classes } = this.props

    return similarContacts && similarContacts.length ? (
      <div className={classes.contactTableContainer}>
        <Table padding="dense">
          <TableHead className={classes.tableHeader}>
            <TableRow>
              <TableCell className={classes.contactTableCell}>{t('ID')}</TableCell>
              <TableCell className={classes.contactTableCell}>{t('type')}</TableCell>
              <TableCell className={classes.contactTableCell}>{t('firstName')}</TableCell>
              <TableCell className={classes.contactTableCell}>{t('lastName')}</TableCell>
              <TableCell className={classes.contactTableCell}>{t('date')}</TableCell>
              <TableCell className={classes.contactTableCell}>{t('time')}</TableCell>
              <TableCell className={classes.contactTableCell}>{t('callDuration')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {take(similarContacts, 10).map(this.renderContactRow, this)}
          </TableBody>
        </Table>
      </div>
    ) : (
      <div>{t('noSimilarContacts')}</div>
    )
  }

  render() {
    const { open, loading, error, onClose, onOpen, t, classes } = this.props

    return (
      <Dialog open={open} onClose={onClose} onEnter={() => onOpen()} auto-qa-id={`${autoQaIdPrefix}dialog`} data-testid={`${autoQaIdPrefix}dialog`}>
        <DialogTitle>{t('findSimilarContacts')}</DialogTitle>
        <DialogContent>
          {loading && (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          )}
          {!loading && error && (
            <div>
              <Typography color="secondary" align="center">
                {t('error')}
              </Typography>
              <Typography color="secondary" align="center">
                {t('unableToLoadSimilarContacts')}
              </Typography>
            </div>
          )}
          {!loading && !error && this.renderContactsTable()}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary" auto-qa-id={`${autoQaIdPrefix}button-Close`} data-testid={`${autoQaIdPrefix}button-Close`}>
            {t('close')}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export { FindSimilarDialog as UnstyledFindSimilarDialog }

export default withTranslation()(withStyles(styles)(FindSimilarDialog))
